import { render, staticRenderFns } from "./UserEditFields.vue?vue&type=template&id=3902d046&scoped=true"
import script from "./UserEditFields.vue?vue&type=script&lang=ts"
export * from "./UserEditFields.vue?vue&type=script&lang=ts"
import style0 from "./UserEditFields.vue?vue&type=style&index=0&id=3902d046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3902d046",
  null
  
)

export default component.exports